export default function Link({ href, target = "_self", params, children }) {
    const hrefs = {
	    telefon: function(params) {
	        return [
	            "tel",
	            params && params.phoneNumber || ""
	        ].join(":")
	    },
	    linkedin: "https://www.linkedin.com/in/yannick-gustin-6685a565/",
	    email: function(params) {
	        return [
	            "mailto",
	            params.email
	        ].join(":")
	    },
	    localityMap: "https://fr.wikipedia.org/wiki/Willaupuis#/maplink/0",
	    whatsapp: (params) => "https://wa.me/"+params.identity.phoneNumber+"?text="+params.message,
    	website: (params) => params.url,
    	github: params
	}

    const _href = (typeof hrefs[href] === 'function') ? hrefs[href](params) : hrefs[href]

    return (
        <a 
            href={ _href }
            target={ target }
        >{ children }</a>
    )
}